<div class="innerpage-fullwithbanner">
  <h2 class="bighead" *ngIf="principalId!=0">My 1031 Exchanges <span class="offerstatus">{{rowCount|number}}</span></h2>
  <h2 class="bighead" *ngIf="principalId==0">1031 Exchanges<span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="currentMenu!=''"><span>{{currentMenu}}<span style="padding:8px;">|</span></span></li>
    <li *ngIf="authService.Broker()">Dashboards<span style="padding:8px;">|</span></li>
    <li *ngIf="principalId!=0">My 1031 Exchanges</li>
    <li *ngIf="principalId==0">1031 Exchanges</li>
  </ul>
</div>
<div class="featuredproperties user-list-wrap section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div list-box table-fixed margin0">
      <div class="tabstyle2 offerdetailstab-padding pos-relative">
        <ul class="switchingproperty margin-bottom-15 offerlistingtab">
          <li [class.active]="activeTab == tabs.Active">
            <a href="javascript:void(0);" (click)="onTabClick(tabs.Active)">
              Active
            </a>
          </li>
          <li [class.active]="activeTab == tabs.InActive">
            <a href="javascript:void(0);" (click)="onTabClick(tabs.InActive)">
              Inactive
            </a>
          </li>

        </ul>
        <div class="absolutesearch">
          <div class="floatinghead clearfix">
            <div class="rightside clearfix">
              <div class="search-sec">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i class="fa fa-search icon" aria-hidden="true"></i>
              </div>
              <a class="filter btn  btn-circle btn-green adduserbtn" *ngIf="isAdmin" href="javascript:void(0);" placement="left" tooltip="Create New Exchange" trigger="mouseenter:mouseleave" (click)="openCreateExchangeModel(CreateExchange)"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
              <a class="filter btn  btn-circle btn-green adduserbtn" *ngIf="isAdmin && IsDemoEnv" href="javascript:void(0);" placement="left" tooltip="Refresh Date" trigger="mouseenter:mouseleave" (click)="saveDemoDate()"><i class="fa fa-refresh icon" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table basictable row-border hover" id="dtTable" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th style="width:80px;" data-orderable="false">Action</th>
              <th class="sticky-left z-100">Exchange ID</th>
              <th *ngIf="!IsPrincipal" class="min-width-td">Principal</th>
              <th class="min-width-75">Start Date - End Date</th>
              <th>Days Left</th>
              <th>Created Date</th>
              <th>Recent Activity Date</th>
              <th>Offers Placed</th>
              <th *ngIf="IsPrincipal || isAdmin">Brokers Assigned</th>
              <th *ngIf="IsPrincipal">Proceeds</th>
              <th *ngIf="isAdmin">1031 Dashboard</th>
              <th *ngIf="isAdmin">1031 Properties</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users;let i = index ">
              <td class="whitespacenowrap">
                <div class="d-flex" *ngIf="user?.IsDeletedUser==0">
                  <div *ngIf="loggedinUserId == 0" class="btn-group rightdropdown" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                            aria-controls="dropdown-basic" placement="top" tooltip="Action">
                      <i class="fa fa-cog" aria-hidden="true"></i>
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                        role="menu" aria-labelledby="button-basic">
                      <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal(template,'panlestyle',user.ID);">Assign Brokers</a></li>
                    </ul>
                  </div>
                  <ng-container *ngIf="loggedinUserId === 0">
                    <div class="btn-group" *ngIf="!user.IsEBRA_Accepted && !user.IsEBRALinkSent">
                      <a href="javascript:void(0);" (click)="openConfirmSendLink(user.UserId)" class="remove" tooltip="Send Agreement Link" placement="top">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div class="btn-group agreement-link" *ngIf="!user.IsEBRA_Accepted && user.IsEBRALinkSent">
                      <a href="javascript:void(0);" (click)="openConfirmSendLink(user.UserId)" class="remove" tooltip="{{'Resend Agreement Link. Last Sent on :'+ (user.EBRASendDate | date: 'M/d/yyyy h:mm a') }}" placement="top">
                        <i class="fa fa-share-square-o" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div class="btn-group" *ngIf="user.IsEBRA_Accepted && user.EBRAPath">
                      <a class="view" href="{{user.EBRAPath}}" download target="_blank" placement="left" tooltip="Download Agreement" triggers="hover">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                      </a>
                    </div>
                  </ng-container>
                  <div class="btn-group whitespacenowrap ss">
                    <a *ngIf="(loggedinUserId != 0) && ((principalId != 0 && user.IDStatus !='Rejected')|| (BrokerId != 0 && user.IDStatus !='Rejected'))" href="javascript:void(0);" routerLink="/1031-registration/{{user.ExGuid}}" [queryParams]="{compaignPage:'true',prevroute:'1031 Prospects',link:router.url}" class="blueone" tooltip="Edit" placement="top">
                      <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                    </a>
                    <div class="msg-wrap" *ngIf="viewMessageIcon">
                      <a tooltip="Message" placement="top" class="blueone" (click)="openMessageTab(templateMessageTab,'panlestyle messagepanel',user)"><i class="icon-chat icon"></i></a>
                      <sup class="message-count-unread msg" title="Unread" *ngIf="user.UnReadMessageCount > 0"> {{user.UnReadMessageCount}} </sup>
                      <sup class="message-count-byme msg" title="Delivered" *ngIf="user.IsSendByMe">  </sup>
                      <sup class="message-count-read msg" title="No new message" *ngIf="user.UnReadMessageCount == 0 && !user.IsSendByMe && user.IsGroupCreated"> </sup>
                    </div>
                  </div>
                </div>
              </td>
              <td class="sticky-left">
                <p><a href="javascript:void(0);" (click)="viewDetail(user.ExGuid)">{{ user.HeadId }}</a></p>
                <!--<p *ngIf="user?.IsDeletedUser==1">{{ user.HeadId }}</p>-->
              </td>

              <td *ngIf="!IsPrincipal">
                <p *ngIf="isAdmin&&user?.IsDeletedUser==0">
                  <a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:user.Guid, prevroute:'1031 Exchanges', link : '1031-exchanges', activeTab:activeTab}">{{ user.Buyer }}</a>
                </p>

                <p *ngIf="isAdmin&&user?.IsDeletedUser==1" style="font-weight:600">
                  {{ user.Buyer }}
                </p>
                <p *ngIf="!isAdmin" style="font-weight:600">{{ user.Buyer }}</p>
                <p *ngIf="user.Phone">{{ user.Phone | phone }}</p>
                <p *ngIf="user.Email">{{user.Email}}</p>
              </td>

              <td>
                <p *ngIf="!user.ProjectedSaleDate">-</p>
                <p *ngIf="user.ProjectedSaleDate">
                  {{convertUTCDateToLocalDateSale(user.ProjectedSaleDate)| date:'MM/dd/yyyy'}} -
                  {{Validation.DateAdd(convertUTCDateToLocalDateSale(user.ProjectedSaleDate),180)| date:'MM/dd/yyyy'}}
                </p>
              </td>
              <td>
                <p *ngIf="user.DaysLeft>0" class="whitespacenowrap">{{user.DaysLeft}}</p>
                <p *ngIf="user.DaysLeft<0" class="whitespacenowrap">Exceeded</p>
                <p *ngIf="user.DaysLeft==null">-</p>
              </td>
              <td><p class="whitespacenowrap">{{ (user.CreatedDate) ? (Validation.convertUTCDateToLocalDate(user.CreatedDate)| date:'MM/dd/yyyy') : '-'}}</p></td>
              <td><p class="whitespacenowrap">{{ (user.RecentActivityDate) ? (Validation.convertUTCDateToLocalDate(user.RecentActivityDate)| date:'MM/dd/yyyy') : '-'}}</p></td>
              <td><p>{{ user.OfferCount ? user.OfferCount : '-'}}</p></td>
              <td *ngIf="IsPrincipal || isAdmin">
                <p>{{(user.BrokerAssigned) ? brokerAssigned_3(user.BrokerAssigned) :'-'}}</p>
                <p class="ellipsis-text commentpara" *ngIf="brokerAssigned_count(user.BrokerAssigned) >0"><button style="background:none!important; color:#2a8edd; border:none;  padding:0!important; font: inherit;cursor: pointer;" container="body" triggers="focus" popover="{{brokerAssigned_others(user.BrokerAssigned)}}">(+{{brokerAssigned_count(user.BrokerAssigned)}})</button></p>
              </td>
              <td *ngIf="IsPrincipal"><p class="whitespacenowrap">{{(user.Proceeds) ? '$ '+ (user.Proceeds | number:0) : '-'}}</p></td>
              <td *ngIf="isAdmin" style="text-align:center">
                <label class="custom-checkbox withoutlabel" *ngIf="user?.IsDeletedUser==0">
                  <input type="checkbox" [(ngModel)]="user.IsDashboard1031Enabled" (change)="grant1031DashboardAccess(user.Guid,$event,user.ID)" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>
              <td *ngIf="isAdmin" style="text-align:center">
                <label class="custom-checkbox withoutlabel"  *ngIf="user?.IsDeletedUser==0">
                  <input type="checkbox" [(ngModel)]="user.AccessTo1031" (change)="grant1031AccessConfirmation(user.Guid,$event, Confirmation1031ListingAccess, 'deleteOffermodal')" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>

            </tr>
          </tbody>
          <tfoot>
            <tr *ngIf="users?.length == 0 && !IsLoading">
              <td colspan="15" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>


<ng-template #template class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Assign Broker
      <span class="badge">{{assignedBrokerCount|number}}</span>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">Broker</label>
      <div class="select-dropdown  multiselectdesign select-check d-flex">
        <!--<angular2-multiselect [data]="brokers" [(ngModel)]="brokersSelected" class="flex-1 margin-right-10" [settings]="defaultBrokerSettings" #broker></angular2-multiselect>-->
        <mat-form-field>
          <mat-select [(ngModel)]="brokersSelected" (click)="addClassToOverlayContainer();" multiple placeholder="Select Brokers">

            @if (brokersSelected?.length > 1) {
            <mat-select-trigger (click)="$event.stopPropagation()">
              <span>{{ brokersSelected?.length }} items selected</span>
            </mat-select-trigger>
            }
            <mat-option (click)="$event.stopPropagation()">
              <ngx-mat-select-search #searchKey
                                     [disableInitialFocus]="true"
                                     [hideClearSearchButton]="true"
                                     [clearSearchInput]="false"
                                     placeholderLabel="Search broker..."
                                     noEntriesFoundLabel="Nothing found...">
              </ngx-mat-select-search>
            </mat-option>

            @for (broker of brokers | arraySearch : 'name' : searchKey.value;; track broker) {
            <mat-option [value]="broker.id">{{broker.name}}</mat-option>
            }
            <mat-option class="matoptionnodata" *ngIf="brokers.length === 0" disabled>
              Nothing found...
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button class="btn btn-success btn-lg add-btn" [disabled]="hideAssignbtn" (click)="addBrokerToList();" tooltip="Add to list" placement="top">
          <i _ngcontent-jtf-c3="" aria-hidden="true" class="fa fa-plus icon"></i>
        </button>
      </div>
      <p class="redtext" *ngIf="BrokerInput.BrokerId==0 && isSubmit">Please select broker </p>
    </div>
    <!--<div class="text-right">
        <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>

    </div>-->
    <br />
    <div>
      <ul class="connection-list brokerlist" *ngIf="ExchangeInvitesList?.length !==0">
        <li class="clearfix" *ngFor="let invitee of ExchangeInvitesList">
          <img [src]="invitee.PhotoPath !=='' ? invitee.PhotoPath  :'/../../../assets/img/default-profile-img.png'" />
          <div class="right">
            <h6 class="d-flex">
              <span class="invitee-name">{{invitee.Name}}</span>
              <span class="ml-auto d-flex ht-25">
                <a class="remove" (click)="removeBrokerLst(invitee);" href="javascript:void(0);" tooltip="Remove" placement="left"><i _ngcontent-yfq-c3="" aria-hidden="true" class="icofont icofont-close"></i></a>
              </span>
            </h6>

            <p>
              <i class="icon-phone icon"></i> {{invitee.Phone|phone}}
            </p>
            <p>
              <i class="icon-message icon"></i> {{invitee.Email}}
            </p>
            <p style="min-height:25px" class="margin-top-10">
              <label class="custom-checkbox" style="border:0 !important;padding-left:30px;">
                <input type="checkbox" name="Agent" [(ngModel)]="invitee.IsPrimaryAgent" (change)="onChange(invitee)" [checked]="invitee.IsPrimaryAgent" class="ng-pristine ng-valid ng-touched">
                Primary Broker
                <i></i>

              </label>
            </p>
          </div>
        </li>

        <li class="margin-top-20 text-right">
          <p *ngIf="validationMsg" class="redtext">
            Please select a Primary Broker
          </p>
          <button class="btn btn-lg btn-default margin-right-10" (click)="modalRef.hide()">Cancel</button>
          <button class="btn btn-success btn-lg" style="width:110px !important" (click)="saveBrokerDetails();">Save</button>
        </li>
      </ul>
    </div>
  </div>

</ng-template>

<ng-template #Changestatus>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Inquiry Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to {{statusName}} ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="ChangeInquirystatus();modalRef.hide();">Yes</button>
    </div>
  </div>

</ng-template>
<ng-template #templateMessageTab>
  <app-messages-view [SelexchangeId]="selectedExchange" [fromExchangeView]="true" [modalRef]="modalRef"></app-messages-view>
</ng-template>

<ng-template #DeleteModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalDeleteBroker.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Please select a primary broker</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalDeleteBroker.hide()">Ok</button>
    </div>
  </div>
</ng-template>

<ng-template #CreateExchange class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Create New Exchange
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group autocomplete-design">
      <label class="form-label">First Name<span class="star">*</span></label>
      <ng-select [items]="dataService$ | async"
                 bindLabel="Name"
                 bindValue="Name"
                 [hideSelected]="true"
                 [loading]="loading"
                 (keyup)="onFirstnameChange($event)"
                 (change)="onBuyerSelect($event);$event.stopPropagation();"
                 [typeahead]="dataServiceInput$"
                 [minTermLength]="0"
                 [searchable]="true"
                 [(ngModel)]="exchangeInputModel.firstname"
                 #firstname="ngModel"
                 [clearSearchInput]="false" (blur)="onSearchBlur($event)">
      </ng-select>


      <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.firstname) && isSubmit) ||(firstname?.invalid && firstname?.touched)">First Name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Last Name<span class="star">*</span></label>
      <input class="form-control" [(ngModel)]="exchangeInputModel.lastname" #lastname="ngModel" type="text" maxlength="50">
      <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.lastname) && isSubmit) ||(lastname.invalid && lastname.touched)">Last Name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Phone Number<span class="star">*</span></label>
      <input class="form-control" #phone="ngModel" mask='(000) 000-0000' id="txtphone" [(ngModel)]="exchangeInputModel.phone" type="text">
      <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.phone) && isSubmit) ||(phone.invalid && phone.touched)">Phone Number is required </p>
      <p class="redtext" *ngIf="(!Validation.IsinValid(exchangeInputModel.phone) && !Validation.isPhoneNumber(exchangeInputModel.phone) && isSubmit)">Invalid Phone number </p>
    </div>
    <div class="form-group">
      <label class="form-label">Email Address<span class="star">*</span></label>
      <input [disabled]="!isEditAllowed" class="form-control" [(ngModel)]="exchangeInputModel.email" #email="ngModel" type="text" maxlength="50">
      <p class="redtext" *ngIf="(Validation.IsinValid(exchangeInputModel.email) && isSubmit) ||(email.invalid && email.touched)">Email Address is required </p>
      <p class="redtext" *ngIf="(!Validation.IsinValid(exchangeInputModel.email) && !Validation.isEmail(exchangeInputModel.email) && isSubmit)">Invalid Email Address </p>
    </div>
    <div class="form-group">
      <label class="form-label">Total Sale Price</label>
      <div class="textbox-with-btn-left">
        <input class="form-control" dropSpecialCharacters="false" #SalePrice="ngModel" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="exchangeInputModel.totalsaleprice" value="{{exchangeInputModel.totalsaleprice|number}}" maxlength="18"><span class="leftlabel">$</span>
      </div>
    </div>
    <div class="form-group">
      <label class="form-label">Sold/Projected sale date</label>
      <div class="textbox-date">
        <input bsDatepicker class="form-control" #SaleDate="ngModel" placement="auto" [(ngModel)]="exchangeInputModel.sold_projectedsaledate" type="text">
        <i class="icofont icofont-ui-calendar icon"></i>
      </div>
    </div>
    <div class="form-group">
      <label class="form-label">Broker</label>
      <div class="select-dropdown  multiselectdesign select-check">
        <!--<angular2-multiselect [data]="brokersNewExchange" [(ngModel)]="brokersSelectedNewExchange" [settings]="defaultBrokerSettings" #broker></angular2-multiselect>-->
        <mat-form-field>
          <mat-select [(ngModel)]="brokersSelectedNewExchange" (click)="addClassToOverlayContainer();" multiple placeholder="Select Brokers">
            @if (brokersSelectedNewExchange?.length > 1) {
            <mat-select-trigger>
              <span>{{ brokersSelectedNewExchange?.length }} items selected</span>
            </mat-select-trigger>
            }
            @for (broker of brokersNewExchange; track broker) {
            <mat-option [value]="broker.id" class="multi-dropdown-item no-border">{{broker.name}}</mat-option>
            }
            <mat-option class="matoptionnodata" *ngIf="brokersNewExchange==null ||brokersNewExchange?.length === 0" disabled>
              Nothing found...
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
      <button class="btn btn-success btn-lg" [disabled]="hideAssignbtn" (click)="submitInquiry();">Create Exchange</button>
    </div>
  </div>

</ng-template>

<ng-template #Confirmation>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure, you want to send the "1031 Trade Participation Agreement" link to </h6>
      <h6 class="displayvalue">{{sendToUserLink}} ? </h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefConfirmation.hide();">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="SendLinkToEBRA()">Send</button>
    </div>
  </div>
</ng-template>
<ng-template #Confirmation1031ListingAccess>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">This will change the 1031 Access of all the Exchanges of this user, are you sure to continue?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="cancelConfirmation()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="grant1031Access()">Yes</button>
    </div>
  </div>
</ng-template>
